"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _row = _interopRequireDefault(require("../../../core/row"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _formatDateRange = _interopRequireDefault(require("../../../../utils/formatDateRange"));
var _occasion = _interopRequireDefault(require("occasion"));
var _getLateFeesApplyDate = _interopRequireDefault(require("../../../../competitionFunctions/getLateFeesApplyDate"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("li", null, "Entries Accepted on the Day");
class CompetitionInfo extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getLateFeesApply", comp => {
      const applyDate = (0, _getLateFeesApplyDate.default)(comp);
      if (!applyDate) return null;
      return /*#__PURE__*/_react.default.createElement("li", null, "Late Fees Apply: ", (0, _occasion.default)(applyDate, 'D MMMM'));
    });
    _defineProperty(this, "_closedDate", comp => {
      if (comp.closedForOnlineEntryDate >= comp.competitionDays[0].dayDate) return null;
      const closed = (0, _occasion.default)(comp.closedForOnlineEntryDate, 'D MMMM');
      if (comp.onDayEntriesAccepted) return /*#__PURE__*/_react.default.createElement("li", null, "Online Entries Closed as of: ", closed);
      return /*#__PURE__*/_react.default.createElement("li", null, "Entries Closed as of: ", closed);
    });
  }
  render() {
    const comp = this.props.competition;
    const location = comp.site && comp.site.county && comp.site.county.countyName;
    const mapLink = !comp.site || !comp.site.latitude || !comp.site.longitude ? null : 'https://maps.google.com/maps?q=' + comp.site.latitude + ',' + comp.site.longitude;
    return /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 6
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "list-unstyled"
    }, /*#__PURE__*/_react.default.createElement("li", null, "Club: ", comp.organisingClubName), /*#__PURE__*/_react.default.createElement("li", null, "Organiser: ", comp.organiserName), /*#__PURE__*/_react.default.createElement("li", null, "Email:", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: 'mailto:' + comp.organiserEmail + '?subject=' + comp.competitionName
    }, comp.organiserEmail))), !comp.site ? null : /*#__PURE__*/_react.default.createElement("ul", {
      className: "list-unstyled"
    }, !comp.site.webSlug ? null : /*#__PURE__*/_react.default.createElement("li", null, "Venue:", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: 'http://www.canoeslalom.co.uk/' + comp.site.webSlug,
      target: "_blank"
    }, comp.site.location)), !location ? null : /*#__PURE__*/_react.default.createElement("li", null, "County: ", location, " "), !mapLink ? null : /*#__PURE__*/_react.default.createElement("li", null, "Google Maps:", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: mapLink,
      target: "_blank"
    }, "Show map")), !comp.site.postCode ? null : /*#__PURE__*/_react.default.createElement("li", null, "Post Code: ", comp.site.postCode), !comp.site.what3words ? null : /*#__PURE__*/_react.default.createElement("li", null, "What3Words:", ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: 'https://what3words.com/' + comp.site.what3words,
      target: "_blank"
    }, comp.site.what3words)))), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 6
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "list-unstyled text-sm-right"
    }, /*#__PURE__*/_react.default.createElement("li", null, "Competition Date(s): ", (0, _formatDateRange.default)(comp.competitionDays.map(d => d.dayDate)))), /*#__PURE__*/_react.default.createElement("ul", {
      className: "list-unstyled text-sm-right"
    }, /*#__PURE__*/_react.default.createElement("li", null, "Entry Limits: ", comp.entryLimitsText), this._closedDate(comp), !comp.onDayEntriesAccepted ? null : _ref), /*#__PURE__*/_react.default.createElement("ul", {
      className: "list-unstyled text-sm-right"
    }, comp.entryFees.map((ef, i) => /*#__PURE__*/_react.default.createElement("li", {
      key: i
    }, ef)), this._getLateFeesApply(comp), !comp.protestCharity || !comp.protestCharity.length ? null : /*#__PURE__*/_react.default.createElement("li", null, "Protest Fees To: ", comp.protestCharity))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CompetitionInfo, "partials", {
  Competition: {
    displayedNotes: true,
    organiserName: true,
    organiserEmail: true,
    competitionName: true,
    organisingClubName: true,
    protestCharity: true,
    entryFees: true,
    lateFeesDueDate: true,
    entryLimitsText: true,
    closedForOnlineEntryDate: true,
    onDayEntriesAccepted: true,
    competitionDays: {
      dayDate: true
    },
    competitionDivisions: {
      lateFee: true
    },
    site: {
      location: true,
      latitude: true,
      longitude: true,
      postCode: true,
      what3words: true,
      webSlug: true,
      county: {
        countyName: true
      }
    }
  }
});
var _default = exports.default = CompetitionInfo; // a(href="https://maps.google.com/maps?q=" + site.postcode.replace(/ /g, '+') target="_blank") map